import { render, staticRenderFns } from "./SelectInsurerDialog.vue?vue&type=template&id=52f04f20&"
import script from "./SelectInsurerDialog.vue?vue&type=script&lang=js&"
export * from "./SelectInsurerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports